import React from "react";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../../lib/motion";

const steps = [
  { n: "01", t: "Apply", d: "Submit your enquiry so we can understand your business and what you need." },
  { n: "02", t: "Consultation", d: "We'll walk through your current setup and identify what needs to be built or refined." },
  { n: "03", t: "Build & Setup", d: "Your full backend, systems, and documents are created for you." },
  { n: "04", t: "Handover", d: "You receive everything structured, organised, and ready to use." },
];

export default function HowItWorks() {
  return (
    <section id="process" data-testid="how-section" className="py-28 sm:py-40">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <motion.div {...fadeUp} className="max-w-2xl">
          <p className="overline mb-6">— How it works</p>
          <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-[color:var(--charcoal)] leading-[1.08]">
            A calm, considered process
            <span className="italic text-[color:var(--gold)]"> from start to finish</span>.
          </h2>
        </motion.div>
        <motion.div {...stagger} className="mt-16 grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 relative">
          <div
            className="hidden md:block absolute top-12 left-0 right-0 h-px"
            style={{ background: "linear-gradient(90deg, transparent, var(--gold), transparent)", opacity: 0.4 }}
          />
          {steps.map((s) => (
            <motion.div key={s.n} {...fadeUp} className="relative" data-testid={`step-${s.n}`}>
              <div className="step-num">{s.n}</div>
              <h3 className="mt-6 font-serif-display text-2xl text-[color:var(--charcoal)] font-medium">
                Step {Number(s.n)} — {s.t}
              </h3>
              <p className="mt-3 text-sm text-[color:var(--text-secondary)] leading-relaxed">
                {s.d}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
